import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import LinearProgress from '@mui/material/LinearProgress';
import React from 'react';

import Box from '@mui/material/Box';
import { useQuery } from '@tanstack/react-query';
import { fetchVisitorCardStatus } from '../../api/mobileapi';
import { VisitorData } from '../../api/types';
import { AdamsError, getErrorMessage } from '../../utils/errors';
import { AccessSituationBanner } from '../AccessSituationBanner/AccessSituationBanner';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import { VisitorTemporaryBadge } from '../VisitorTemporaryBadge/VisitorTemporaryBadge';

interface VisitorCardScanResultProps {
    nonce: string | undefined;
    translations: Record<string, string>;
}

export const VisitorCardScanResult: React.FC<VisitorCardScanResultProps> = ({ nonce, translations }) => {
    const { data, error, isLoading } = useQuery<VisitorData, AdamsError>(
        ['visitorCardCheck', nonce],
        () => fetchVisitorCardStatus({ data: { nonce }, language: 'EN' }),
        {
            enabled: !!nonce,
        }
    );

    if (isLoading) {
        return <LinearProgress />;
    }

    return error ? (
        <Card>
            <CardContent>
                <ErrorMessage
                    errorMessage={getErrorMessage(error)}
                    title={translations.ERROR_NOT_ACP_QR_CODE_TITLE}
                    translations={translations}
                />
            </CardContent>
        </Card>
    ) : (
        <Card sx={{ boxShadow: 3, maxWidth: 600, margin: 'auto' }}>
            <CardContent sx={{ padding: 0 }}>
                <AccessSituationBanner accessSituation={true} description={'CERN site'} />
                <Box sx={{ padding: '0 1rem', marginTop: '-4rem' }}>
                    {data && <VisitorTemporaryBadge userData={data}></VisitorTemporaryBadge>}
                </Box>
            </CardContent>
        </Card>
    );
};
